import { CourseCard2 } from "./Card2.0/Card"
import { SingleContainer, CardContainer } from "./Container"
import { Icon, VolverArriba } from "./Image"
import { Text, Title } from "./Text"

export const OfertaFormativaSection = (props)=>{
    return(
        <>
        <Title 
            text={props.title} 
            marginTop='-10%'
            textAlign='center'
            fontFamily='Damion-Regular' 
            // fontSize=''
            color='#D45FEE'/>
        <SingleContainer>
            <Text 
                text={props.warning}
                style={{marginTop:'2%', marginBottom:'2%'}}
                fontFamily='Montserrat-Regular' 
                fontSize='24px'
                color='#303030'/>
            <Icon src={props.icon}/>
        </SingleContainer>
        <CardContainer>
            {props.data.map((data, index)=>(
                <CourseCard2 
                    key={index}
                    display={data.display}
                    video={data.video}
                    backgroundColorHeader={data.backgroundColorHeader}
                    area={data.area}
                    capacity={`${data.capacity} cupos`}
                    type={data.type}
                    course={data.course}
                    description={data.description}
                    teacher={data.teacher}
                    population={data.population}
                    schedule={data.schedule}
                    requirements={data.requirements}
                    onClick={()=>props.onClick(data.course, data.trimCourse)}/>
            ))}
        </CardContainer>
        <SingleContainer>
            <VolverArriba src={props.backToTopImg} onClick={props.backToTopClick}/>
        </SingleContainer>
        </> 
    )
}